<div class="home-tabs" *ngIf="!(overviewService.showOverview$ | async)">
	<button type="button" [class.active]="activeTab === 'workflows'" (click)="setActiveTab('workflows')">Workflows</button>
	<button type="button" [class.active]="activeTab === 'forms'" (click)="setActiveTab('forms')">Forms</button>
</div>

<div class="workflow-section card" *ngIf="activeTab === 'workflows' && !(overviewService.showOverview$ | async)">
	<div class="workflow-heading">
		<div>
			<h1>Workflows</h1>
			<p>Start assigned workflows or act on workflow stages waiting for you.</p>
		</div>
	</div>

	<div *ngIf="workflowsLoading" class="workflow-muted">Loading workflows...</div>
	<div *ngIf="workflowError" class="workflow-error">{{ workflowError }}</div>

	<div *ngIf="!workflowsLoading && !workflowError">
		<div class="wf-filter-tabs">
			<button type="button" class="wf-filter-tab" [class.active]="workflowFilter === 'tasks'" (click)="setWorkflowFilter('tasks')">
				<svg class="wf-tab-icon" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2"/><rect x="9" y="3" width="6" height="4" rx="1"/><path d="m9 14 2 2 4-4"/></svg>
				My Tasks
			</button>
			<button type="button" class="wf-filter-tab" [class.active]="workflowFilter === 'start'" (click)="setWorkflowFilter('start')">
				<svg class="wf-tab-icon" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M12 8v8M8 12h8"/></svg>
				New workflow
			</button>
			<button type="button" class="wf-filter-tab" [class.active]="workflowFilter === 'history'" (click)="setWorkflowFilter('history')">
				<svg class="wf-tab-icon" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 3v5h5"/><path d="M3.05 13A9 9 0 1 0 6 5.3L3 8"/><path d="M12 7v5l3 2"/></svg>
				View History
			</button>
		</div>

		<!-- My Tasks -->
		<section class="workflow-group wf-group-flush" *ngIf="workflowFilter === 'tasks'">
			<div *ngIf="needsMyAction.length === 0 && scheduledAvailable.length === 0" class="workflow-muted">No workflows need your action.</div>

			<!-- Scheduled (due) + in-flight tasks share one grid; scheduled show first. -->
			<div class="workflow-list" *ngIf="scheduledAvailable.length > 0 || needsMyAction.length > 0">
				<article class="workflow-card" *ngFor="let workflow of scheduledAvailable" role="link" tabindex="0"
					[attr.data-status]="'awaiting'"
					[attr.aria-label]="workflow.name + ', scheduled' + (workflow.isOverdue ? ', overdue' : '')"
					(click)="openWorkflow(workflow)"
					(keydown.enter)="openWorkflow(workflow)"
					(keydown.space)="$event.preventDefault(); openWorkflow(workflow)">
					<div class="wf-card-top">
						<div class="wf-card-head">
							<span class="wf-type">Scheduled workflow</span>
							<span class="wf-status">Available</span>
						</div>
						<h3 class="wf-subject" [title]="workflow.name">{{ workflow.name }}</h3>
					</div>

					<p class="wf-desc" *ngIf="workflow.description">{{ workflow.description }}</p>

					<div class="wf-flow" *ngIf="stageFlow(workflow.stageCount).length">
						<div class="wf-flow-steps">
							<ng-container *ngFor="let step of stageFlow(workflow.stageCount); let last = last; let i = index">
								<span class="wf-flow-step" [class.wf-flow-start]="i === 0">{{ step }}</span>
								<span class="wf-flow-arrow" *ngIf="!last">→</span>
							</ng-container>
						</div>
					</div>

					<div class="wf-stage-row" *ngIf="workflow.isOverdue">
						<span class="wf-stage-label"></span>
						<span class="wf-flag" title="This workflow is past its scheduled window">
							<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M8 2.5 1.8 13.3h12.4L8 2.5Z"/><path d="M8 6.6v3.1"/><path d="M8 11.6h.01"/></svg>
							Overdue
						</span>
					</div>

					<dl class="wf-facts">
						<div><dt>Version</dt><dd>{{ workflow.version }}</dd></div>
						<div><dt>Stages</dt><dd>{{ workflow.stageCount }}</dd></div>
					</dl>

					<div class="wf-card-foot wf-foot-plain">
						<button type="button" class="wf-action is-primary" (click)="$event.stopPropagation(); openWorkflow(workflow)">
							{{ workflow.actionLabel || 'Start' }}
						</button>
					</div>
				</article>

				<article class="workflow-card" *ngFor="let item of pagedNeedsMyAction" role="link" tabindex="0"
					[attr.data-status]="statusToken(item)"
					[attr.data-state]="isTerminalWorkflowItem(item) ? 'terminal' : null"
					[attr.aria-label]="cardAriaLabel(item)"
					(click)="openWorkflowItem(item)"
					(keydown.enter)="openWorkflowItem(item)"
					(keydown.space)="$event.preventDefault(); openWorkflowItem(item)">
					<div class="wf-card-top">
						<div class="wf-card-head">
							<span class="wf-type" *ngIf="item.summaryTitle">{{ item.name }}</span>
							<span class="wf-status">{{ pillLabel(item) }}</span>
						</div>
						<h3 class="wf-subject" [title]="item.summaryTitle || item.name">{{ item.summaryTitle || item.name }}</h3>
					</div>

					<div class="wf-stage" *ngIf="item.stageCount">
						<div class="wf-track" role="img" [attr.aria-label]="stageProgressLabel(item)">
							<span class="wf-seg" *ngFor="let seg of stageSegments(item)"
								[class.is-done]="seg === 'done'" [class.is-current]="seg === 'current'"></span>
						</div>
						<div class="wf-stage-row">
							<span class="wf-stage-label">{{ stageProgressLabel(item) }}</span>
							<!-- RT-21: overdue rides the stage row — the SLA belongs to the current stage. -->
							<span class="wf-flag" *ngIf="overdueLabel(item)" title="This stage has passed its time budget">
								<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M8 2.5 1.8 13.3h12.4L8 2.5Z"/><path d="M8 6.6v3.1"/><path d="M8 11.6h.01"/></svg>
								{{ overdueLabel(item) }}
							</span>
						</div>
					</div>

					<dl class="wf-facts">
						<div><dt>Submitted</dt><dd>{{ formatShort(item.startedAt) }}</dd></div>
						<div><dt>Updated</dt><dd>{{ relativeTime(item.updatedAt) }}</dd></div>
						<div *ngIf="item.initiatorName"><dt>Initiator</dt><dd [title]="item.initiatorName">{{ item.initiatorName }}</dd></div>
						<div *ngFor="let f of summaryMetaFields(item)"><dt>{{ f.label }}</dt><dd [title]="f.value">{{ f.value }}</dd></div>
					</dl>

					<div class="wf-card-foot">
						<span class="wf-ref" title="Reference">WF-{{ item.workflowItemId }}</span>
						<button type="button" class="wf-action is-primary" (click)="$event.stopPropagation(); openWorkflowItem(item)">
							{{ rowActionLabel(item) }}
						</button>
					</div>
				</article>
			</div>
		</section>

		<!-- Start New -->
		<section class="workflow-group wf-group-flush" *ngIf="workflowFilter === 'start'">
			<div *ngIf="onDemandAvailable.length === 0" class="workflow-muted">No workflows available to start.</div>
			<div class="workflow-list" *ngIf="onDemandAvailable.length > 0">
				<article class="workflow-card" *ngFor="let workflow of pagedAvailableToStart" role="link" tabindex="0"
					[attr.data-status]="workflow.hasDraft ? 'draft' : 'progress'"
					[attr.aria-label]="workflow.name + ', ' + (workflow.hasDraft ? 'Draft saved' : 'Available to start')"
					(click)="openWorkflow(workflow)"
					(keydown.enter)="openWorkflow(workflow)"
					(keydown.space)="$event.preventDefault(); openWorkflow(workflow)">
					<div class="wf-card-top">
						<div class="wf-card-head">
							<span class="wf-type">{{ workflow.isScheduled ? 'Scheduled workflow' : 'Workflow template' }}</span>
							<span class="wf-status">{{ workflow.hasDraft ? 'Draft saved' : 'Available' }}</span>
						</div>
						<h3 class="wf-subject" [title]="workflow.name">{{ workflow.name }}</h3>
					</div>

					<p class="wf-desc" *ngIf="workflow.description">{{ workflow.description }}</p>

					<div class="wf-flow" *ngIf="stageFlow(workflow.stageCount).length">
						<div class="wf-flow-steps">
							<ng-container *ngFor="let step of stageFlow(workflow.stageCount); let last = last; let i = index">
								<span class="wf-flow-step" [class.wf-flow-start]="i === 0">{{ step }}</span>
								<span class="wf-flow-arrow" *ngIf="!last">→</span>
							</ng-container>
						</div>
					</div>

					<div class="wf-stage-row" *ngIf="workflow.isScheduled && workflow.isOverdue">
						<span class="wf-stage-label"></span>
						<span class="wf-flag" title="This workflow is past its scheduled window">
							<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M8 2.5 1.8 13.3h12.4L8 2.5Z"/><path d="M8 6.6v3.1"/><path d="M8 11.6h.01"/></svg>
							Overdue
						</span>
					</div>

					<dl class="wf-facts">
						<div><dt>Version</dt><dd>{{ workflow.version }}</dd></div>
						<div><dt>Stages</dt><dd>{{ workflow.stageCount }}</dd></div>
					</dl>

					<div class="wf-card-foot wf-foot-plain">
						<button type="button" class="wf-action is-primary" (click)="$event.stopPropagation(); openWorkflow(workflow)">
							{{ workflow.actionLabel || 'Start' }}
						</button>
					</div>
				</article>
			</div>
		</section>

		<!-- History -->
		<div class="workflow-history wf-group-flush" *ngIf="workflowFilter === 'history'">
			<div class="wf-history-toolbar" *ngIf="!historyLoading && !historyError && historyItems.length > 0">
				<div class="wf-history-search">
					<img src="assets/search.svg" alt="" />
					<input type="text" placeholder="Search history" (input)="onHistorySearch(hsearch.value)" #hsearch />
				</div>
				<div class="wf-history-filter-wrap">
					<button type="button" class="wf-history-filter-btn" [class.active]="historyStatusFilter !== 'all'" (click)="toggleHistoryFilter()" title="Filter by status">
						<img src="assets/filter.svg" alt="Filter" />
						<span class="wf-history-filter-dot" *ngIf="historyStatusFilter !== 'all'"></span>
					</button>
					<div class="wf-history-filter-menu" *ngIf="historyFilterOpen">
						<button type="button" class="wf-history-filter-option" *ngFor="let opt of historyStatusOptions"
							[class.selected]="historyStatusFilter === opt.value" (click)="setHistoryStatusFilter(opt.value)">
							{{ opt.label }}
						</button>
					</div>
				</div>
				<!-- #3: toggle submission order (newest ↔ oldest) -->
				<button type="button" class="wf-history-sort-btn" (click)="toggleWorkflowSort()"
					[title]="workflowSort === 'newest' ? 'Showing newest first — click for oldest first' : 'Showing oldest first — click for newest first'">
					<img src="assets/sort.svg" alt="Sort" onerror="this.style.display='none'" />
					<span>{{ workflowSort === 'newest' ? 'Newest first' : 'Oldest first' }}</span>
				</button>
			</div>
			<div class="wf-history-filter-backdrop" *ngIf="historyFilterOpen" (click)="toggleHistoryFilter()"></div>
			<div *ngIf="historyLoading" class="workflow-muted">Loading workflow history...</div>
			<div *ngIf="historyError" class="workflow-error">{{ historyError }}</div>
			<div *ngIf="!historyLoading && !historyError && historyItems.length === 0" class="workflow-muted">
				No workflow history yet.
			</div>
			<div *ngIf="!historyLoading && !historyError && historyItems.length > 0 && pagedHistoryItems.length === 0" class="workflow-muted">
				No workflow history matches your search.
			</div>
			<div class="workflow-list" *ngIf="pagedHistoryItems.length > 0">
					<article class="workflow-card" *ngFor="let item of pagedHistoryItems" role="link" tabindex="0"
						[attr.data-status]="statusToken(item)"
						[attr.data-state]="isTerminalWorkflowItem(item) ? 'terminal' : null"
						[attr.aria-label]="cardAriaLabel(item)"
						(click)="openWorkflowItem(item, true)"
						(keydown.enter)="openWorkflowItem(item, true)"
						(keydown.space)="$event.preventDefault(); openWorkflowItem(item, true)">
						<div class="wf-card-top">
							<div class="wf-card-head">
								<span class="wf-type" *ngIf="item.summaryTitle">{{ item.name }}</span>
								<span class="wf-status">{{ pillLabel(item) }}</span>
							</div>
							<h3 class="wf-subject" [title]="item.summaryTitle || item.name">{{ item.summaryTitle || item.name }}</h3>
						</div>

						<div class="wf-stage" *ngIf="item.stageCount">
							<div class="wf-track" role="img" [attr.aria-label]="stageProgressLabel(item)">
								<span class="wf-seg" *ngFor="let seg of stageSegments(item)"
									[class.is-done]="seg === 'done'" [class.is-current]="seg === 'current'"></span>
							</div>
							<div class="wf-stage-row">
								<span class="wf-stage-label">{{ stageProgressLabel(item) }}</span>
							</div>
						</div>

						<dl class="wf-facts">
							<div><dt>Submitted</dt><dd>{{ formatShort(item.startedAt) }}</dd></div>
							<div><dt>Updated</dt><dd>{{ relativeTime(item.updatedAt) }}</dd></div>
							<div *ngIf="item.initiatorName"><dt>Initiator</dt><dd [title]="item.initiatorName">{{ item.initiatorName }}</dd></div>
						</dl>

						<div class="wf-card-foot">
							<span class="wf-ref" title="Reference">WF-{{ item.workflowItemId }}</span>
							<button type="button" class="wf-action" (click)="$event.stopPropagation(); openWorkflowItem(item, true)">
								{{ rowActionLabel(item) }}
							</button>
						</div>
					</article>
				</div>
		</div>
		<div class="wf-pagination" *ngIf="activeWorkflowCount > 0">
			<button type="button" class="wf-page-arrow" [disabled]="workflowPage === 1" (click)="setWorkflowPage(workflowPage - 1)" aria-label="Previous page">‹</button>
			<button type="button" class="wf-page-num" *ngFor="let p of cardPageList(activeWorkflowCount)" [class.active]="p === workflowPage" (click)="setWorkflowPage(p)">{{ p }}</button>
			<button type="button" class="wf-page-arrow" [disabled]="workflowPage === totalCardPages(activeWorkflowCount)" (click)="setWorkflowPage(workflowPage + 1)" aria-label="Next page">›</button>
		</div>
	</div>
</div>

<div [ngClass]="{ 'custom-section': true, card: true }" *ngIf="activeTab === 'forms' && !(overviewService.showOverview$ | async)">
	<div class="heading">
		<div class="heading-text">Good day {{this.username}}</div>
		<div class="heading-text">Today is {{this.today}}</div>
		<h1>
			Take a look at your forms
		</h1>
		<div class="filter-container">
			<div class="col-2">
				<button [ngClass]="this.logSheetType === 'none'? 'filter-buttons active' : 'filter-buttons'"
					(click)="handleFilter(ScheduledType.none)">
					All
				</button>
				<button 
					[ngClass]="this.logSheetType == 'Shared Form'? 'filter-buttons active' : 'filter-buttons'"
					(click)="handleFilter(ScheduledType.scheduled)">
					Shared Forms
				</button>
				<button
					[ngClass]="this.logSheetType == 'Standard Form Submissions'? 'filter-buttons active' : 'filter-buttons'"
					(click)="handleFilter(ScheduledType.onDemand)">
					Standard Form Submissions
				</button>
				<button 
					[ngClass]="this.logSheetType == 'Standard Form Templates'? 'filter-buttons active' : 'filter-buttons'"
					(click)="handleFilter(ScheduledType.onDemandForm)">
					Standard Form Templates
				</button>
			</div>
			<div class="col-1">
				<div class="search-wrapper">
					<button class="search-icon-btn" *ngIf="!isSearchOpen" (click)="toggleSearch()">
						<img src="../../../assets/search.svg" alt="Search">
					</button>
					<div class="search-expand" *ngIf="isSearchOpen">
						<button class="search-icon-btn search-icon-inline-btn" (click)="toggleSearch()">
							<img src="../../../assets/search.svg" alt="Search">
						</button>
						<input
							type="text"
							class="search-input"
							placeholder="Search Forms"
							[(ngModel)]="searchQuery"
							(input)="onSearchInput()"
							autofocus
						/>
					</div>
				</div>
				<div class="filter-btn-wrapper">
					<button
						class="filter-form-filter-button"
						[class.filter-shake]="filterPulseActive"
						(click)="toggleFilterOverlay()">
						<img src="../../../assets/filter.svg" alt="Filter">
						Filter
						<span class="filter-active-dot" *ngIf="hasActiveFilters"></span>
					</button>

					<!-- FILTER PANEL -->
					<div class="filter-dropdown-menu" *ngIf="displayFilterOverlay">
						<!-- Header: Filter + Clear All -->
						<div class="filter-dropdown-header">
							<div class="filter-header-left">
								<span class="filter-title">Filter</span>
								<div class="filter-title-accent"></div>
							</div>
							<button class="clear-all-btn" (click)="clearAllFilters()">Clear All</button>
						</div>

						<div class="filter-dropdown-content">
							<!-- Status Section (collapsible) -->
							<div class="filter-section">
								<div class="filter-section-header" (click)="toggleStatusSection()">
									<span class="filter-section-title">Status</span>
									<span class="filter-section-toggle" [ngClass]="{ 'collapsed': !statusSectionOpen }">&#8963;</span>
								</div>
								<div class="checkbox-group" *ngIf="statusSectionOpen">
									<label *ngFor="let option of statusOptions" 
										class="checkbox-label" 
										[ngClass]="{ 'checkbox-selected': isStatusSelected(option.value) }">
										<input 
											type="checkbox" 
											[checked]="isStatusSelected(option.value)"
											(change)="toggleStatusFilter(option.value)">
										<span>{{ option.label }}</span>
									</label>
								</div>
							</div>

							<!-- Date Range Section -->
							<div class="filter-section">
								<div class="filter-section-header">
									<span class="filter-section-title">Date Range</span>
								</div>
								<div class="radio-group">
									<label *ngFor="let option of dateRangeOptions" class="radio-label">
										<input 
											type="radio" 
											name="dateRange"
											[value]="option.value"
											[checked]="selectedDateRange === option.value"
											(change)="setDateRange(option.value)">
										<span>{{ option.label }}</span>
									</label>
								</div>
							</div>
						</div>

						<div class="filter-dropdown-footer">
							<button class="apply-filters-btn" (click)="applyFilters()">Apply Filters</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>

	<!-- Backdrop to close filter when clicking outside -->
	<div class="filter-dropdown-backdrop" *ngIf="displayFilterOverlay" (click)="toggleFilterOverlay()"></div>

	<div class="no-search-results-wrapper" *ngIf="searchResults !== null && searchResults.length === 0">
		<div class="no-search-icon-circle">
			<img src="../../../assets/search.svg" alt="No results" class="no-search-icon">
		</div>
		<h3 class="no-search-heading">No forms found</h3>
		<p class="no-search-subtext">Your search “{{ searchQuery }}” did not match any records. Please try again.</p>
	</div>

	<div class="log-container">
		<div class="log-item" 
			(click)="checkLogsheet(log)"
			[ngClass]="{
				'reposition-container': !log.submittedDate,
				'logsheet-disabled': log.status === 'inProgress' && log.currentUser !== currentUser && log.logSheetTemplated.scheduleType.toLowerCase() !== 'ondemand'
			}" *ngFor="let log of (searchResults !== null ? pagedSearchResults : logs); let i = index">
			<div class="log-heading">
				<span class="log-name">
					{{ log.versionNumber > 0 ? log.logSheetTemplated.logSheetName + ' V' + log.versionNumber :
					log.logSheetTemplated.logSheetName }}
				</span>
				<p class="schedule-type" [ngClass]="getStatusColor(log.status)">{{
					getStatusDisplayText(log.status) }}</p>
			</div>
			<div class="log-info log-submitted-info">
				<p class="submitted-date" *ngIf="log.submittedDate && !(log.logSheetTemplated.scheduleType.toLowerCase() === 'ondemand' && !log.isGeneratedOnDemandLogSheet)">
					Last Submitted {{ stringToShortDate(log.submittedDate) }} {{ stringToTime(log.submittedDate) }}
				</p>
			</div>
			<div class="log-info" [ngClass]="(!log.lastModifiedDate || (log.isGeneratedOnDemandLogSheet && !log.submittedDate)) ? 'hide-field' : '' " *ngIf="!(log.logSheetTemplated.scheduleType.toLowerCase() === 'ondemand' && !log.isGeneratedOnDemandLogSheet)">
				<p *ngIf="log.executedByUserName && log.status !== 'available'" class="current-user">
					<img src="../../../assets/user-log-icon.svg" alt="user-icon" />
					<span class="username-text"
						#usernameExec
						(mouseenter)="isTruncated(usernameExec) && showTooltip('exec-' + i)"
						(mouseleave)="hideTooltip()">
						{{ log.executedByUserName }}
					</span>
					<span class="username-tooltip" *ngIf="hoveredUsername === 'exec-' + i">{{ log.executedByUserName }}</span>
				</p>
				<p>
					<img src="../../../assets/calendar.svg" alt="calendar" />{{
					stringToDate(log.executionTime) || stringToDate(log.lastModifiedDate)
					}}
				</p>
				<p>
					<img src="../../../assets/clock.svg" alt="clock" />{{
					stringToTime(log.executionTime) || stringToTime(log.lastModifiedDate)
					}}
				</p>
			</div>

			<div class="log-edits" *ngIf="!(log.logSheetTemplated.scheduleType.toLowerCase() === 'ondemand' && !log.isGeneratedOnDemandLogSheet)">
				<div class="edits-container">
					<div>
						<span class="total-edits">{{
							log.adminEditCount + log.nonAdminEditCount || 0
							}}
							edits</span>
						<span>{{ log.adminEditCount || 0 }} Admin</span>
						<span>{{ log.nonAdminEditCount || 0 }} Non-Admin</span>
					</div>

					<!-- <button 
						type="button"
						(click)="resetLogsheetStatus(log)"
						class="reset-status"
						*ngIf="log.status == 'inProgress' && (log.currentUser === currentUser || role === Roles.superAdmin)"
					>
						<img
						src="../../../assets/reset-white.svg"
						alt="reset" />
						Reset
					</button> -->
				</div>
			</div>
		</div>
	</div>
	<div class="pagination" *ngIf="(searchResults !== null ? pagedSearchResults : logs).length !== 0">
		<button [style.opacity]="activeCurrentPage === 1 ? 0.5 : 1" type="button" (click)="performDecrement()">
			<img class="arrow flipped" src="../../assets/triangle-icon.svg" alt="navigate back" />
		</button>
		<div *ngFor="let item of activeLoopArray; let i = index">
			<button *ngIf="
					item <= activeTotalPages &&
					activeCurrentPage > 2 &&
					activeCurrentPage < activeTotalPages - 1
						? item >= activeCurrentPage - 2 && item <= activeCurrentPage + 2
						: activeCurrentPage === 1
						? item >= activeCurrentPage && item <= activeCurrentPage + 4
						: activeCurrentPage === 2
						? item >= activeCurrentPage - 1 && item <= activeCurrentPage + 3
						: activeCurrentPage === activeTotalPages - 1
						? item >= activeCurrentPage - 3 && item <= activeCurrentPage + 1
						: activeCurrentPage === activeTotalPages
						? item >= activeCurrentPage - 4 && item <= activeCurrentPage
						: true
				" [style]="activeCurrentPage === item ? selectedPage : ''" (click)="setCurrentPage(item)" class="page-number">
				{{ item }}
			</button>
		</div>
		<button [style.opacity]="activeCurrentPage === activeTotalPages ? 0.5 : 1" type="button" (click)="performIncrement()">
			<img class="arrow" src="../../assets/triangle-icon.svg" alt="navigate forward" />
		</button>
	</div>
</div>
